import { TeamMember } from '../types';
import michaelImage from '../assets/michael-coffie.jpg';
import carysImage from '../assets/Carys.jpg';
import sofiaImage from '../assets/Sofia.jpg';
import nanaImage from '../assets/Nana.jpg';
export const teamMembers: TeamMember[] = [
  {
    name: 'Michael Coffie',
    role: 'Co-Founder',
    title: 'Lead Developer',
    education: 'Health Science and Public Health with a Minor in Health Management and Policy, University of Miami',
    image: michaelImage,
    description: "Michael Coffie is the technical mastermind behind Green Guard, bringing extensive experience in full-stack development and a passion for creating innovative financial solutions. His expertise in React, TypeScript, and cloud technologies drives the platform's robust functionality.\n\nAs a Health Science Science student at the University of Miami, Michael combines academic excellence with practical application, constantly pushing the boundaries of what's possible in fintech. His commitment to clean, efficient code and user-centric design makes him an invaluable leader of our development team.",
    social: {
      github: 'https://github.com/michaelcoffie',
      linkedin: 'https://www.linkedin.com/in/michaelcoffie/'
    }
  },
  {
    name: 'Carys Bernard',
    role: 'Co-Founder',
    title: 'App Designer',
    education: 'Interactive Media, University of Miami',
    image: carysImage,
    description: "Carys Bernard is the creative force behind Green Guard's user experience, designing the app with precision and innovation using Figma. As an Interactive Media major, she combines artistry with functionality to craft intuitive and visually compelling interfaces. Her keen eye for design and determination to push creative boundaries make her an invaluable part of the team.\n\nBeyond Green Guard, Carys applies her expertise as a Web Developer Assistant at the University of Miami Herbert Business School, where she enhances digital experiences and refines her development skills. Her passion for technology and design drives her to create seamless, user-centered solutions.",
    social: {
      github: 'https://github.com/carysbux',
      linkedin: 'https://www.linkedin.com/in/carysbernard/'
    }
  },
  {
    name: 'Sofia Belisario Costa ',
    role: 'Co-Founder',
    title: 'Strategic Visionary',
    education: 'Chemical Engineering, University of Miami',
    image: sofiaImage,
    description: "Sofia Belisario Costa is the creative strategist behind Green Guard, shaping its vision and direction from the start. As a co-founder, she developed the pitch and played a pivotal role in brainstorming ideas that define the platform.\n\nWith a strong foundation in analytical thinking from her Chemical Engineering studies, she brings a unique problem-solving approach to financial strategy. Her dedication to innovation and accessibility ensures that Green Guard remains both impactful and user-focused.",
    social: {
      github: '',
      linkedin: 'https://www.linkedin.com/in/sofia-belis%C3%A1rio-costa-772819230?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app'
    }
},
    {
        name: 'Nana Kessie',
        role: 'Co-Founder',
        title: 'Technical Strategist',
        education: 'Software Engineering, University of Miami',
        image: nanaImage,
        description: "Nana Owusu played a fundamental role in shaping Green Guard’s core functionality, combining his technical expertise with innovative thinking. As a co-founder, he contributed to pitch development and was instrumental in conceptualizing the platform’s features, ensuring a seamless integration of AI-driven financial tools. As a Software Engineering major at the University of Miami, Nana applies his problem-solving mindset and technical acumen to optimize Green Guard’s architecture. His passion for leveraging technology to create meaningful solutions helps drive the platform’s development, making financial management more intuitive and accessible for all users.",
        social: {
          github: 'https://github.com/NanaKessie',
          linkedin: 'https://www.linkedin.com/in/nana-owusu-kessie'
        }
      }
  
]; 